<mat-chip-grid aria-label="Fish selection" class="mt-label">
  @for (chip of items; track chip) {
    <mat-chip [color]="chip.color" selected [ngClass]="inverse">{{ chip.name }} </mat-chip>
  }
</mat-chip-grid>
